export const HERO_CLASSES = [
  { key: 'SCOUT', scene: 'scout' },
  { key: 'MEDIC', scene: 'cleric' },
  { key: 'SOCIAL', scene: 'bard' },
  { key: 'TANK', scene: 'warrior' },
  { key: 'ENVIRONMENT', scene: 'druid' },
  { key: 'TECH', scene: 'mage' },
  { key: 'CRAFTER', scene: 'crafter' },
  { key: 'NUTRITION', scene: 'alchemist' },
  { key: 'LOGISTICS', scene: 'logistics' },
  { key: 'GUARDIAN', scene: 'guardian' },
];
